import BaseService from './BaseService'

class InvoiceLabelService extends BaseService {
  constructor () {
    super('/invoice-labels')
  }
}

export default new InvoiceLabelService()
